import Toaster from '@meforma/vue-toaster';

const options = {
    position: 'top-right',
    duration: 3000,
    dismissible: true
};

export { Toaster as Toast, options };
